import { h } from "preact";

function IconFigma() {
    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#xrpawonxaa)">
                <g clip-path="url(#9vzadyaq0b)">
                    <path d="M5.308 16C6.794 16 8 14.805 8 13.333v-2.667H5.308c-1.486 0-2.692 1.195-2.692 2.667C2.616 14.805 3.822 16 5.308 16z" fill="#0ACF83"/>
                    <path d="M2.617 8c0-1.472 1.206-2.667 2.692-2.667H8v5.333H5.308c-1.486 0-2.691-1.194-2.691-2.666z" fill="#A259FF"/>
                    <path d="M2.617 2.667C2.617 1.195 3.823 0 5.31 0H8v5.333H5.309c-1.486 0-2.692-1.194-2.692-2.666z" fill="#F24E1E"/>
                    <path d="M8 0h2.692c1.486 0 2.692 1.195 2.692 2.667 0 1.472-1.206 2.667-2.692 2.667H8V0z" fill="#FF7262"/>
                    <path d="M13.383 8c0 1.472-1.206 2.667-2.692 2.667C9.205 10.667 8 9.472 8 8c0-1.472 1.206-2.667 2.692-2.667 1.486 0 2.691 1.195 2.691 2.667z" fill="#1ABCFE"/>
                </g>
            </g>
            <defs>
                <clipPath id="xrpawonxaa">
                    <path fill="#fff" d="M0 0h16v16H0z"/>
                </clipPath>
                <clipPath id="9vzadyaq0b">
                    <path fill="#fff" d="M0 0h16v16H0z"/>
                </clipPath>
            </defs>
        </svg>
    );
}

export default IconFigma;
